var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostPaidLob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 23,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.571289,
    y: 0.575012,
    width: 14.8571,
    height: 21.85,
    rx: 1.5,
    stroke: "#666666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71436 3.48345H10.2858H5.71436Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71436 3.48345H10.2858",
    stroke: "#666666",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.5H15H1Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.5H15",
    stroke: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71432 21.275C8.18771 21.275 8.57146 20.8888 8.57146 20.4125C8.57146 19.9361 8.18771 19.55 7.71432 19.55C7.24093 19.55 6.85718 19.9361 6.85718 20.4125C6.85718 20.8888 7.24093 21.275 7.71432 21.275Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25208 8.16623V6.20219C5.25208 5.95668 5.44469 5.74994 5.70151 5.74994C5.95833 5.74994 6.15095 5.94376 6.15095 6.20219V8.16623C6.15095 8.41174 5.95833 8.61848 5.70151 8.61848C5.44469 8.61848 5.25208 8.41174 5.25208 8.16623ZM11.0948 7.26179H11.5571C12.1093 7.26179 12.5716 7.71404 12.5716 8.28258V14.9371C12.5716 15.4927 12.1221 15.9579 11.5571 15.9579H4.44316C3.89099 15.9579 3.42871 15.5056 3.42871 14.9371V8.28258C3.42871 7.72696 3.87815 7.26179 4.44316 7.26179H4.90544V9.05786H6.52341V7.26179H9.47686V9.05786H11.0948V7.26179ZM4.44312 14.9369H11.5571V9.93636H4.44312V14.9369ZM9.86201 6.20219V8.16623C9.86201 8.41174 10.0546 8.61848 10.3114 8.61848C10.5683 8.61848 10.7609 8.41174 10.7609 8.16623V6.20219C10.7609 5.94376 10.5683 5.74994 10.3114 5.74994C10.0546 5.74994 9.86201 5.95668 9.86201 6.20219Z",
    fill: "#E40000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostPaidLob);
export default __webpack_public_path__ + "static/media/post-paid-lob.b111a8cc877a43ef59e4163382350b0a.svg";
export { ForwardRef as ReactComponent };